class QuestionDrawer extends HTMLElement {
  constructor() {
    super();

    this.formLoaded = false;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#QuestionDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setQuestionButtonAccessibility();
  }

  setQuestionButtonAccessibility() {
    const questionButtonLinks = document.querySelectorAll('a[href^="#contact"]');
    if (!questionButtonLinks) return;

    questionButtonLinks.forEach((questionButton) => {
      questionButton.addEventListener('click', () => {
        this.open(questionButton);
      });
    });
  }

  loadHubSpotForm() {
    if (this.formLoaded) return Promise.resolve();

    const container = this.querySelector('#HubSpotForm');
    const loader = this.querySelector('.drawer-embed-loader');
    if (!container) return Promise.resolve();

    const region = container.dataset.region;
    const portalId = container.dataset.portalId;
    const formId = container.dataset.formId;
    const embedScriptSrc = container.dataset.embedScript;

    if (!portalId || !formId || !embedScriptSrc) return Promise.resolve();

    const createForm = () => {
      if (typeof window.hbspt === 'undefined' || !window.hbspt.forms) return;

      window.hbspt.forms.create({
        region: region,
        portalId: portalId,
        formId: formId,
        target: '#HubSpotForm',
        onFormReady: () => {
          loader?.classList.add('hidden');
        },
      });

      this.formLoaded = true;
    };

    if (typeof window.hbspt !== 'undefined' && window.hbspt.forms) {
      createForm();
      return Promise.resolve();
    }

    if (document.querySelector(`script[src="${embedScriptSrc}"]`)) {
      return new Promise((resolve) => {
        const check = setInterval(() => {
          if (typeof window.hbspt !== 'undefined' && window.hbspt.forms) {
            clearInterval(check);
            createForm();
            resolve();
          }
        }, 50);
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.charset = 'utf-8';
      script.src = embedScriptSrc;
      script.async = true;
      script.onload = () => {
        createForm();
        resolve();
      };
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.loadHubSpotForm().catch(() => {
      this.querySelector('.drawer-embed-loader')?.classList.add('hidden');
    });

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('QuestionDrawer');
        const focusElement =
          this.querySelector('.question-drawer__inner') || this.querySelector('.question-drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('question-drawer', QuestionDrawer);
